"use strict";

/* Constants */
const googleMapsUtils = require("../utils/googleMapsUtils");

// Chile Coordinates
const initialLocation = {
    latitude : -33.478043,
    longitude: -70.599010
};

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;

    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

/**
* Initializes the Google Maps with the store locations
* @param {Object} initialLocation - the initial location of the map
* @param {Object} storeLocations - the parsed JSON object with the store locations
*/
function initGoogleMaps() {
    const infowindow = new google.maps.InfoWindow();
    const latlng     = new google.maps.LatLng(initialLocation.latitude, initialLocation.longitude);
    const mapOptions = {
        scrollwheel : false,
        zoom        : 6,
        center      : latlng
    };
    window.googleMap = new google.maps.Map($(".map-canvas")[0], mapOptions);
    let storeLocations = $(".map-canvas").attr("data-locations");

    window.googleMapLocations = storeLocations = JSON.parse(storeLocations);

    const bounds = new google.maps.LatLngBounds();

    Object.keys(storeLocations).forEach(function (key) {
        var item          = storeLocations[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker        = new google.maps.Marker({
            animation: google.maps.Animation.DROP,
            position : storeLocation,
            map      : window.googleMap,
        });

        marker.addListener("click", function () {
            infowindow.setOptions({
                content : item.infoWindowHtml
            });
            infowindow.open(window.googleMap, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (storeLocations && storeLocations.length !== 0) {
        if (storeLocations.length === 1) {
            window.googleMap.setCenter(bounds.getCenter());
            window.googleMap.setZoom(15);
        } else {
            window.googleMap.fitBounds(bounds);
        }
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    const $resultsDiv = $(".results");
    const $storeLocations     = $(".map-canvas");
    const hasResults  = data.stores.length > 0;

    $resultsDiv.empty()
        .data("has-results", hasResults)
        .data("radius", data.radius)
        .data("search-key", data.searchKey);

    $storeLocations.attr("data-locations", data.locations);

    if ($storeLocations.data("has-google-api")) {
        initGoogleMaps();
    } else {
        $(".store-locator-no-apiKey").show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(showAllStores) {
    const $regionErrorSelect     = $(".js-current-state");
    const $communeErrorSelect    = $(".js-dropdown-cities");
    const $storeLocatorContainer = $(".store-locator-container");
    const $form                  = $("form.store-locator");
    let url                      = $form.attr("action");
    let urlParams                = {};
    let regionId                 = $(".js-current-state option:selected");
    let communeId                = $(".js-dropdown-cities option:selected");

    if (showAllStores) {
        urlParams = {
            showAllStores : true
        };
    } else {
        if (!regionId || regionId.data("not-selectable")) {
            regionId = null;
            $regionErrorSelect.addClass("is-invalid");
            $regionErrorSelect[0].scrollIntoView({ behavior: "smooth", block: "start" });
        }

        if (!communeId || communeId.data("not-selectable")) {
            communeId = null;
            $communeErrorSelect.addClass("is-invalid");
            $regionErrorSelect[0].scrollIntoView({ behavior: "smooth", block: "start" });
        }

        if (!regionId || !communeId) {
            return;
        }

        $regionErrorSelect.removeClass("is-invalid");
        $communeErrorSelect.removeClass("is-invalid");

        urlParams = {
            regionId  : regionId.val(),
            communeId : communeId.val()
        };
    }

    let payload = showAllStores ? {} : $form.serialize();

    $storeLocatorContainer.spinner().start();

    $.ajax({
        url      : appendToUrl(url, urlParams),
        type     : $form.attr("method"),
        data     : payload,
        dataType : "json",
        success  : function (data) {
            updateStoresResults(data);

            if ($(window).width() < 768) {
                $(".store-locator-container")[0].scrollIntoView({ behavior: "smooth", block: "start" });
            }
            $storeLocatorContainer.spinner().stop();
        },
        error    : function () {
            $storeLocatorContainer.spinner().stop();
        }
    });

    return false;
}

module.exports = {
    /**
    * Initializes the Google Maps API and sets up event listeners for the store locator page
    * @returns {void}
    */
    init : function () {
        const $body = $("body");

        if ($(".map-canvas").data("has-google-api")) {
            initGoogleMaps();
        } else {
            $(".store-locator-no-apiKey").show();
        }

        const $resultsDiv = $(".results");
        const storeResultsHtml = $resultsDiv.data("stores-results-html");

        if (storeResultsHtml) {
            $resultsDiv.append(storeResultsHtml);
        }

        $body.on("click", ".js-see-store-in-map", function (e) {
            e.preventDefault();
            const $this = $(this);

            googleMapsUtils.setCenter(
                $this.data("latitude"),
                $this.data("longitude")
            );

            $(".maps-canvas-container")[0].scrollIntoView({ behavior: "smooth", block: "start" });
        });
    },

    /**
    * Handles the store locator form submission and show all button click
    * @param {boolean} showAll - whether to show all stores or not
    */
    search : function () {
        $(document).on("submit", ".store-locator-container form.store-locator", function (e) {
            e.preventDefault();
            search(false);
        });

        $(document).on("click", ".store-locator-container button.btn-show-all", function (e) {
            e.preventDefault();
            search(true);
        });
    }
};
